import React from "react";
import "./IleFoxes.scss";
import IslandVideo from "../../components/ui/IslandVideo";

export default function IleFoxes() {
	return (
		<>
			<div id='ilefoxes' className='Island'>
				<div className='video_container'>
					<IslandVideo
						webmSrc='/videos/iles/ile_foxes-vp9-chrome.webm'
						mp4Src='/videos/iles/ile_foxes-hevc-safari.mp4'
					/>
				</div>
				<div className='text'>
					<h2 className='island_title'>Foxes</h2>
					<p>Découvrez-en plus sur le spectacle et rebranchez La Liesse ! </p>
				</div>
			</div>
		</>
	);
}
